import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import {
  Card,
  Text,
  Flex,
  Box,
  Checkbox,
  Button,
} from '../../../../design-system';
import axios from 'axios';
import Alert from '../../../../helpers/alert';
import { ALL_DOWNLOADS_OBJ, CHECKBOX_FIELDS } from './constants';
import { ERR_MSG } from '../../../../globalConstants';
import useDownload from '../../../../hooks/use-download';

const filterSubmission = (values) =>
  Object.keys(ALL_DOWNLOADS_OBJ).reduce((acc, item) => {
    if (!values[item]) {
      acc[item] = false;
    }
    return acc;
  }, values);

const renderFields = (selectAll) =>
  CHECKBOX_FIELDS.map(({ name, label }) => (
    <Box key={name}>
      <Field name={name}>
        {(props) => (
          <Checkbox
            id={name}
            label={label}
            name={props.input.name}
            value={selectAll || props.input.value}
            onChange={(_, v) => {
              props.input.onChange(v);
            }}
            {...props}
          />
        )}
      </Field>
    </Box>
  ));

interface DownloadProps {
  data: { id: any; name: string };
  canEdit?: boolean;
}

const Download = ({ data: { id, name } }: DownloadProps) => {
  const [selectAll, toggleSelectAll] = useState(false);
  const download = useDownload();

  const onSubmit = async (values) => {
    const payload = selectAll
      ? { ...ALL_DOWNLOADS_OBJ, client_id: id }
      : { ...filterSubmission(values), client_id: id };
    try {
      const { data, headers } = await axios.post(`/downloadVault`, payload, {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      download({
        fileName: `${name} Vault`,
        data,
        headers: headers as Record<string, string>,
      });
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };
  return (
    <Card>
      <Card.Header fontWeight={700} fontSize={20}>
        Download Vault
      </Card.Header>
      <Card.Body mt={20}>
        <Text fontWeight={600}>Which sections do you want to download?</Text>
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <form onSubmit={handleSubmit}>
              <Flex mt={20} flexDirection="column">
                <Box>
                  <Field name="selectAll">
                    {(props) => (
                      <Checkbox
                        id="selectAll"
                        label="Select All"
                        name={props.input.name}
                        value={props.input.value}
                        onChange={(_, v) => {
                          props.input.onChange(v);
                          toggleSelectAll((prev) => !prev);
                        }}
                        {...props}
                      />
                    )}
                  </Field>
                </Box>
                {renderFields(selectAll)}
              </Flex>
              <Button mt={20} disabled={submitting || pristine} type="submit">
                Download
              </Button>
            </form>
          )}
        />
      </Card.Body>
    </Card>
  );
};

export default Download;
